import DateFnsAdapter from '@date-io/date-fns'
import { format } from 'date-fns'

export const dateFns = new DateFnsAdapter()

export function formatDate(date: string | number | Date) {
	const initialDateFnsDate = dateFns.date(date)
	if (!initialDateFnsDate) return ''
	return dateFns.format(initialDateFnsDate, 'fullDateTime24h')
}

export function resetSeconds(date: Date) {
	date.setSeconds(0, 0)
}

function addZeroBeforeNumberLessThan10(num: number): string | number {
	return num < 10 ? `0${num}` : num
}

function getMonth(dateObject: Date): string {
	return addZeroBeforeNumberLessThan10(dateObject.getUTCMonth() + 1) as string
}

function getDay(dateObject: Date): string {
	return addZeroBeforeNumberLessThan10(dateObject.getUTCDate()) as string
}

function getHourMinutesAndSeconds(dateObject: Date): string {
	return `${addZeroBeforeNumberLessThan10(dateObject.getUTCHours())}:${addZeroBeforeNumberLessThan10(
		dateObject.getUTCMinutes(),
	)}:${addZeroBeforeNumberLessThan10(dateObject.getUTCSeconds())}`
}

export const formatDateAsAPIParam = (date: Date | string | null): string | null => {
	if (date) {
		const dateObject = new Date(date as string | number)
		return `${dateObject.getUTCFullYear()}/${getMonth(dateObject)}/${getDay(dateObject)} ${getHourMinutesAndSeconds(
			dateObject,
		)}`
	}
	return null
}

export const formatDateForUserDisplay = (date: string | Date, isUTCTime = true): string => {
	let dateStr = typeof date === 'string' ? date : date.toISOString()
	if (isUTCTime) dateStr += ' UTC'
	const dateObject = new Date(dateStr)
	return format(dateObject, 'yyyy/MM/dd HH:mm:ss')
}

export const formatDateObjectForUserDisplay = (date: string): string => {
	let utcDate = (date += ' UTC')
	const dateObject = new Date(utcDate)
	return formatDate(dateObject)
}

export const formatDateToDayMonthYear = (date: Date): string => {
	return format(date, 'dd-MMM-yyyy')
}
